import Indicator from "../../../components/base/Indicator";
import Icon from "../../../components/base/Icon";
import { OfferView } from "../../enterprise/models/Enterprise";
import { toCount, toMoney } from "../../plancatalog/components/format";


// The sign-up's plan step for a customer who came from an Enterprise offer: the offer they
// signed, and what paying now covers. Nothing to choose -- the figures were agreed already.
export default function EnterpriseOfferStep(props: { offer?: OfferView }) {

    const o = props.offer
    if (!o) return <div className="py-10"><Indicator /></div>

    return (
        <div className="mx-auto" style={{ maxWidth: 560 }}>
            <div className="border border-gray-300 rounded-3 p-6 mb-6">
                <div className="d-flex justify-content-between align-items-start mb-4">
                    <div>
                        <div className="text-primary fw-bold fs-8 text-uppercase">Rinvox Enterprise · {o.reference}</div>
                        <div className="fs-3 fw-bolder text-gray-900">{o.companyName}</div>
                    </div>
                    <div className="text-end">
                        <div className="fs-2 fw-bolder text-gray-900">{toMoney(o.monthly)}</div>
                        <div className="text-gray-500 fs-8">a month{o.billing === "annual" ? ", billed yearly" : ""}</div>
                    </div>
                </div>

                <div className="text-gray-700 fs-7 mb-4">
                    <Icon icon="check" size={11} className="text-success me-2" />{toCount(o.includedUsers)} users at once
                    <br /><Icon icon="check" size={11} className="text-success me-2" />{toCount(o.includedMessages)} messages and {toCount(o.includedMinutes)} call minutes a month
                    <br /><Icon icon="check" size={11} className="text-success me-2" />{toCount(o.includedNumbers)} phone numbers
                    {o.supportTier && <><br /><Icon icon="check" size={11} className="text-success me-2" />{o.supportTier} support</>}
                </div>

                <div className="border-top border-gray-200 pt-4">
                    <div className="d-flex justify-content-between fs-7 mb-1">
                        <span className="text-gray-600">First {o.billing === "annual" ? "year" : "month"}</span>
                        <span className="fw-bold">{toMoney(o.periodPrice)}</span>
                    </div>
                    {
                        o.oneTime > 0 &&
                        <div className="d-flex justify-content-between fs-7 mb-1">
                            <span className="text-gray-600">One-time charges</span>
                            <span className="fw-bold">{toMoney(o.oneTime)}</span>
                        </div>
                    }
                    <div className="d-flex justify-content-between fs-5 mt-2">
                        <span className="fw-bold text-gray-900">Paid now</span>
                        <span className="fw-bolder text-gray-900">{toMoney(o.chargeToday)}</span>
                    </div>
                </div>
            </div>
            <div className="text-gray-500 fs-8 text-center">
                Signed by {o.signedName}. Your card is kept for the renewals; you can change it on your subscription page.
            </div>
        </div>
    )
}
